import React from "react";
import { Typography, Space } from "antd";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Title, Text, Paragraph } = Typography;

const RoomImprovementGauge = () => {
  const rooms = [
    { name: "Bathroom", score: 1.17, color: "#ff4d4f" }, // Ant Design red
    { name: "Bedroom", score: 2.1, color: "#faad14" }, // Ant Design gold
    { name: "Kitchen", score: 2.35, color: "#52c41a" }, // Ant Design green
  ];

  const gaugeData = [
    { name: "Improvement Potential", value: 100 - (rooms[0].score / 3) * 100 },
    { name: "Current Condition", value: (rooms[0].score / 3) * 100 },
  ];

  const getScoreDescription = (score) => {
    if (score >= 2.5) return "Great shape!";
    if (score >= 2) return "Good, but could be better";
    if (score >= 1.5) return "Needs some attention";
    return "Needs significant improvement";
  };

  return (
    <CustomCard
      title={<Title level={4}>Room Improvement Spotlight</Title>}
      className="card-height"
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ width: "100%", height: 120 }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={gaugeData}
                cx="50%"
                cy="100%"
                startAngle={180}
                endAngle={0}
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
              >
                <Cell fill="#f0f0f0" />
                <Cell fill={rooms[0].color} />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <Space direction="vertical" align="center" style={{ width: "100%" }}>
          <Title level={5}>{rooms[0].name}</Title>
          <Text strong>Condition: {getScoreDescription(rooms[0].score)}</Text>
          <Text>Score: {rooms[0].score.toFixed(2)} out of 3</Text>
          <Text type="secondary">
            Potential for Improvement:{" "}
            {(((3 - rooms[0].score) / 3) * 100).toFixed(0)}%
          </Text>
        </Space>
        <Paragraph>
          This gauge shows how much the {rooms[0].name.toLowerCase()} could be
          improved. A fuller gauge means there's more room for enhancement,
          which could potentially increase your property's value.
        </Paragraph>
        <Paragraph type="secondary">
          We've highlighted the {rooms[0].name.toLowerCase()} because it has the
          most potential for improvement among all rooms.
        </Paragraph>
      </Space>
    </CustomCard>
  );
};

export default RoomImprovementGauge;
